import { Breeder, BreederAdminUser, ManagedBreeder } from 'dogpark/types';
import { apiGetRequest, apiPostRequest } from 'utilities/http/api/apiHttp';

export const apiBreeder = {
  getBreeders: () => {
    return apiGetRequest<{ breeders: Breeder[] }>(`breeders`);
  },

  getBreeder: (breederId: number) => {
    return apiGetRequest<{ breeder: Breeder; errors: { value: string[] } }>(
      `breeder/${breederId}`,
    );
  },

  activeBreeder: (breederId: number) => {
    return apiPostRequest<{ success: boolean }>(`breeder/${breederId}/activate`);
  },

  deactivateBreeder: (breederId: number) => {
    return apiPostRequest<{ success: boolean }>(`breeder/${breederId}/deactivate`);
  },

  getBreederAdminUsers: () => {
    return apiGetRequest<{ breederAdminUsers: { data: BreederAdminUser[] } }>(
      `breeder/admin`,
    );
  },

  getBreederAdminUser: (breederId: number) => {
    return apiGetRequest<{ breederAdminUser: BreederAdminUser }>(
      `breeder/${breederId}/admin`,
    );
  },

  getBreederAdminManagedBreeders: (userId: number) => {
    return apiGetRequest<{ managedBreeders: ManagedBreeder[] }>(
      `breeder/admin/${userId}/managed-breeders`,
    );
  },
};
